module.exports = __webpack_public_path__ + "img/armourfuse_m.758dd219.svg";